import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';

const CHAR_CUTOFF = 100;

const DealerResponseContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  padding-top: 24px;
  padding-left: 12px;
`;

const HeaderRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const HeaderText = styled(Text)``;

const PartialReviewStyled = styled(Text)<{ isTextCutOff: boolean }>`
  display: ${(props) => (props.isTextCutOff ? 'block' : 'none')};
`;

const FullReviewStyled = styled(Text)<{ isTextCutOff: boolean }>`
  display: ${(props) => (props.isTextCutOff ? 'none' : 'block')};
`;

const ReadMoreButtonStyled = styled<typeof TextLink>(TextLink)`
  width: auto;
  height: 20px;
  align-items: end;
  text-decoration: none;
  min-width: auto;
  border: none;
  padding: 0;

  svg {
    display: none;
  }
`;

interface DealerResponseProps {
  text: string;
  date: Date;
}

export const DealerResponse = ({ text, date }: DealerResponseProps) => {
  const [isTextCutOff, setIsTextCutOff] = useState(false);
  const onReviewButtonClick = () => {
    setIsTextCutOff(false);
  };
  useEffect(() => {
    if (text.length > CHAR_CUTOFF) {
      setIsTextCutOff(true);
    }
  }, []);
  const readMoreLabel = useI18n(messages.five_star_read_more);
  const readMoreButton = (() => {
    return (
      <>
        ...&nbsp;
        <ReadMoreButtonStyled
          variant="standalone"
          size="md"
          icon="add"
          iconPosition="leading"
          onClick={onReviewButtonClick}
        >
          {readMoreLabel}
        </ReadMoreButtonStyled>
      </>
    );
  })();
  const partialReview = (() => {
    if (isTextCutOff) {
      const cutReview = text.slice(0, CHAR_CUTOFF);
      if (text[CHAR_CUTOFF + 1] === ' ') {
        return cutReview;
      }
      const lastWhiteSpaceIndex = cutReview.lastIndexOf(' ');
      return cutReview.slice(0, lastWhiteSpaceIndex);
    }
    return '';
  })();
  return (
    <DealerResponseContainer>
      <HeaderRowContainer>
        <HeaderText variant={{ order: '2', style: 'bold', type: 'copy' }}>
          {useI18n(messages.five_star_dealer_response)}
        </HeaderText>
        <Text variant={{ order: '2', style: 'bold', type: 'copy' }}>
          {date.toLocaleDateString()}
        </Text>
      </HeaderRowContainer>
      <PartialReviewStyled
        variant={{ order: '1', style: 'bold', type: 'copy' }}
        isTextCutOff={isTextCutOff}
      >
        {partialReview}
        {readMoreButton}
      </PartialReviewStyled>
      <FullReviewStyled
        variant={{ order: '1', style: 'bold', type: 'copy' }}
        isTextCutOff={isTextCutOff}
      >
        {text}
      </FullReviewStyled>
    </DealerResponseContainer>
  );
};
